const  a= [
    {
        id:1,
        postedOn: '2024-01-09',
        title: 'IOS Developer',
        company: 'Apple',
        type: 'Full Time',
        experience: 'Mid Level',
        location: 'In-Office',
        skills: ["SwiftUI", "UiKit", "Core Data"],
        job_link: "https://www.apple.com/careers/"

    
    },

    {
        id:2,
        postedOn: '2024-01-04',
        title: 'FrontEnd Developer',
        company: 'Apple',
        type: 'Full Time',
        experience: 'Mid Level',
        location: 'Remote',
        skills: ["REACT", "ANGULAR", "JAVASCRIPT"],
        job_link: "https://www.apple.com/careers/"

    
    },
    {
        id:3,
        postedOn: '2024-01-03',
        title: 'BackEnd Developer',
        company: 'Facebook',
        type: 'Full Time',
        experience: 'Mid Level',
        location: 'Hybrid',
        skills: ["NODEJS", "PYTHON"],
        job_link: "https://www.metacareers.com/"

    
    },
    {
        id:4,
        postedOn: '2024-01-01',
        title: 'Android Developer',
        company: 'Amazon',
        type: 'Full Time',
        experience: 'Mid Level',
        location: 'Remote',
        skills: ["Java", "Kotlin", "React Native"],
        job_link: "https://www.amazon.jobs/en/"

    
    },
    {
        id:5,
        postedOn: '2023-11-7',
        title: 'FrontEnd Developer',
        company: 'Facebook',
        type: 'Contract',
        experience: 'Senior Level',
        location: 'Hybrid',
        skills: ["REACT", "ANGULAR", "JAVASCRIPT"],
        job_link: "https://www.metacareers.com/"

    
    },
    {
        id:6,
        postedOn: '2023-11-03',
        title: 'IOS Developer',
        company: 'Apple',
        type: 'Full Time',
        experience: 'Junior',
        location: 'In-Office',
        skills: ["SwiftUI", "UiKit", "Core Data"],
        job_link: "https://www.apple.com/careers/"

    
    },
    {
        id:7,
        postedOn: '2023-10-24',
        title: 'Android Developer',
        company: 'Facebook',
        type: 'Part Time',
        experience: 'Fresher',
        location: 'Hybrid',
        skills: ["Java", "Kotlin", "React Native"],
        job_link: "https://www.metacareers.com/"

    
    },
    {
        id:8,
        postedOn: '2023-09-15',
        title: 'FrontEnd Developer',
        company: 'Amazon',
        type: 'Full Time',
        experience: 'Mid Level',
        location: 'Remote',
        skills: ["Java", "Kotlin", "React Native"],
        job_link: "https://www.amazon.jobs/en/"
    
    },
  
]

export default a